import { createAsyncThunk } from '@reduxjs/toolkit';
import { axios } from '@utils/lib';
import { addLoading, removeLoading } from './appAction';
import { Configs, Enums, Paths } from '@utils/constants';
import { ILoginRes, ISuccessResponse } from '@interfaces/apis/response-data';
import AxiosDefault from 'axios';
import { setFacility } from '@redux/reducers/facilitySlice';
import { forceLogout } from './authAction';

export const login = createAsyncThunk(
  '/auth/login',
  async (body: ILoginForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<ILoginRes>(
        Enums.HTTP_METHOD.POST,
        Paths.LOGIN,
        body
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const forgotPassword = createAsyncThunk(
  '/auth/forgotPassword',
  async (body: IForgotPasswordForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<ISuccessResponse>(
        Enums.HTTP_METHOD.POST,
        Paths.FORGOT_PASSWORD,
        body
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const forceChangePassword = createAsyncThunk(
  '/auth/forceChangePassword',
  async (body: IForceChangePasswordForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<ILoginRes>(
        Enums.HTTP_METHOD.POST,
        Paths.FORCE_CHANGE_PASSWORD,
        body
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const changePassword = createAsyncThunk(
  '/auth/changePassword',
  async (body: IChangePasswordForm, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<ILoginRes>(
        Enums.HTTP_METHOD.POST,
        Paths.CHANGE_PASSWORD,
        body
      );
      dispatch(forceLogout());
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue, dispatch, getState }) => {
    dispatch(addLoading());

    try {
      const state = getState() as { auth: AuthState };
      const refreshToken = state.auth.jwtAccessToken;
      const response = await AxiosDefault.post(
        `${Configs.BASE_URL}${Paths.LOGOUT}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${refreshToken}`,
          },
        }
      );
      dispatch(setFacility(null));
      return response.data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);
